import React, { useEffect, useState } from "react";
import { Button, Table, Pagination, Badge, Modal } from "react-bootstrap";
import jsPDF from "jspdf";
import html2canvas from "html2canvas";
import moment from "moment";
import ViewOvertimeModal from "./ViewOvertimeModal";
import { API_URL } from "../..";
import { Icon } from "@iconify/react";
import BulkApproveWithRateModal from "./BulkApproveWithRateModal";
import AddOvertimeModal from "./AddOvertimeModal";

function convertTo12Hour(time24) {
  // Split the time into hours, minutes, seconds
  let [hours, minutes, seconds] = time24.split(':').map(Number);
  
  // Determine AM or PM
  const period = hours >= 12 ? 'PM' : 'AM';
  
  // Convert to 12-hour format
  hours = hours % 12;
  // If hours becomes 0 (midnight or noon), make it 12
  hours = hours ? hours : 12;
  
  // Pad minutes and seconds with leading zero if needed
  const formattedMinutes = minutes.toString().padStart(2, '0');
  const formattedSeconds = seconds.toString().padStart(2, '0');
  
  return `${hours}:${formattedMinutes}:${formattedSeconds} ${period}`;
}


const OvertimeTable = ({ filters }) => {
  const [showAddModal, setShowAddModal] = useState(false);

  const [records, setRecords] = useState([]);
  const [selectedIds, setSelectedIds] = useState([]);
  const [selectedRecord, setSelectedRecord] = useState(null);
  const [pagination, setPagination] = useState({ total: 0, page: 1, limit: 20 });
  const [loading, setLoading] = useState(false);
  const [showBulkRateModal, setShowBulkRateModal] = useState(false);
function convertTo12Hour(time24) {
  // Split the time into hours, minutes, seconds
  let [hours, minutes, seconds] = time24.split(':').map(Number);
  
  // Determine AM or PM
  const period = hours >= 12 ? 'PM' : 'AM';
  
  // Convert to 12-hour format
  hours = hours % 12;
  // If hours becomes 0 (midnight or noon), make it 12
  hours = hours ? hours : 12;
  
  // Pad minutes and seconds with leading zero if needed
  const formattedMinutes = minutes.toString().padStart(2, '0');
  const formattedSeconds = seconds.toString().padStart(2, '0');
  
  return `${hours}:${formattedMinutes} ${period}`;
}

  const fetchOvertime = async (page = 1) => {
    try {
      setLoading(true);
      const query = new URLSearchParams({
        ...filters,
        page,
        limit: pagination.limit,
      });

      const res = await fetch(`${API_URL}/api/overtime/all?${query}`);
      const json = await res.json();

      if (json.success) {
        setRecords(json.data || []);
        setPagination({
          total: json.total,
          page: json.page,
          limit: json.limit,
        });
      }
    } catch (err) {
      console.error("Overtime fetch error:", err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchOvertime(1);
  }, [filters]);

  // Bulk approve/reject
  const handleBulkAction = async (status) => {
    const user = JSON.parse(localStorage.getItem('user'))
    if (selectedIds.length === 0) return alert("No overtime selected!");
    if (!window.confirm(`Confirm ${status} selected requests?`)) return;

    try {
      const res = await fetch(`${API_URL}/api/overtime/bulk/approve`, {
        method: "PUT",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ ids: selectedIds, status, approved_id :user.id }),
      });

      const json = await res.json();
      if (json.success) {
        alert(`Selected overtimes ${status} successfully!`);
        setSelectedIds([]);
        fetchOvertime(pagination.page);
      } else {
        alert(json.message || "Action failed.");
      }
    } catch (err) {
      console.error("Bulk action error:", err);
    }
  };

  // PDF Export
  const handleExportPDF = async () => {
    const table = document.getElementById("overtimeTable");
    const pdf = new jsPDF("l", "pt", "a4");
    const canvas = await html2canvas(table, { scale: 1.3 });
    const imgData = canvas.toDataURL("image/png");
    pdf.addImage(imgData, "PNG", 25, 25, 800, (canvas.height * 800) / canvas.width);
    pdf.save(`Overtime_Report_${moment().format("YYYYMMDD")}.pdf`);
  };

  // Pagination
  const totalPages = Math.ceil(pagination.total / pagination.limit);
  const paginationItems = [];
  for (let i = 1; i <= totalPages; i++) {
    paginationItems.push(
      <Pagination.Item key={i} active={i === pagination.page} onClick={() => fetchOvertime(i)}>
        {i}
      </Pagination.Item>
    );
  }

  const toggleSelect = (id) => {
    setSelectedIds((prev) =>
      prev.includes(id) ? prev.filter((i) => i !== id) : [...prev, id]
    );
  };

  const getStatusBadge = (status) => {
    const variants = {
      pending: "warning",
      approved: "success",
      rejected: "danger",
    };
    return <Badge bg={variants[status] || "secondary"}>{status}</Badge>;
  };

  const handleStatusUpdate = (id, newStatus) => {
    setRecords((prev) =>
      prev.map((r) => (r.id === id ? { ...r, status: newStatus } : r))
    );
  };

  return (
    <div className="card shadow-sm">
      <div className="card-header d-flex justify-content-between align-items-center">
        <h5 className="mb-0">Overtime Requests</h5>
        <div className="d-flex gap-2">
        <Button variant="primary" onClick={() => setShowAddModal(true)}>
  <i className="bi bi-plus-circle me-2"></i> Add Overtime
</Button>
          <Button variant="outline-primary" onClick={handleExportPDF}>
            <i className="bi bi-file-earmark-pdf me-2"></i>Download PDF
          </Button>
          <Button
              variant="success"
              disabled={!selectedIds.length}
              onClick={() => setShowBulkRateModal(true)}
            >
              <i className="bi bi-check-circle me-2"></i>
              Approve with Rates ({selectedIds.length})
        </Button>
          <Button
            variant="danger"
            disabled={!selectedIds.length}
            onClick={() => handleBulkAction("rejected")}
          >
            Reject Selected
          </Button>
        </div>
      </div>

      <div className="card-body table-responsive">
        <Table bordered hover id="overtimeTable" className="align-middle text-center">
          <thead className="table-light">
            <tr>
            <th className="text-center">
  <div className="form-check d-flex justify-content-center">
    <input
      className="form-check-input"
      type="checkbox"
      id="selectAll"
      checked={
        records.length > 0 &&
        selectedIds.length === records.map((r) => r.id).length
      }
      onChange={(e) =>
        setSelectedIds(e.target.checked ? records.map((r) => r.id) : [])
      }
      style={{
        width: "18px",
        height: "18px",
        cursor: "pointer",
      }}
    />
  </div>
</th>

              <th>Employee</th>
              <th>Date</th>
              <th>Start Time</th>
              <th>End Time</th>
              <th>Total Duration</th>
              <th>Status</th>
              <th>Approved By</th>
              <th>Action</th>
            </tr>
          </thead>
          <tbody>
  {records.length > 0 ? (
    records.map((r) => {
      const attachments =
        typeof r.attachments === "string"
          ? JSON.parse(r.attachments)
          : r.attachments || [];

      return (
        <tr key={r.id}>
          {/* ✅ Checkbox column fixed */}
          <td className="align-middle text-center">
            <div className="form-check d-flex justify-content-center">
              <input
                className="form-check-input"
                type="checkbox"
                id={`check-${r.id}`}
                checked={selectedIds.includes(r.id)}
                onChange={() => toggleSelect(r.id)}
                style={{
                  width: "18px",
                  height: "18px",
                  cursor: "pointer",
                }}
              />
            </div>
          </td>

          <td>{r.user?.name || "N/A"}</td>
          <td>{moment(r.date).format("DD MMM YYYY")}</td>
          <td>{convertTo12Hour(r.start_time)}</td>
          <td>{convertTo12Hour(r.end_time)}</td>
          <td>{r.total_duration}</td>
          <td>{getStatusBadge(r.status)}</td>
          <td>{r.approvedBy?.name || "--"}</td>
          <td>
            <Button
              variant="outline-dark"
              size="sm"
              onClick={() =>
                setSelectedRecord({
                  ...r,
                  attachments,
                })
              }
            >
              View
            </Button>
          </td>
        </tr>
      );
    })
  ) : (
    <tr>
      <td colSpan="9" className="text-center py-4">
        {loading ? "Loading..." : "No overtime records found."}
      </td>
    </tr>
  )}
</tbody>
        </Table>

        {totalPages > 1 && (
          <div className="d-flex justify-content-center mt-3">
            <Pagination>{paginationItems}</Pagination>
          </div>
        )}
      </div>

      {/* View Modal */}
      {selectedRecord && (
        <ViewOvertimeModal
          overtime={selectedRecord}
          onClose={() => setSelectedRecord(null)}
          onStatusChange={handleStatusUpdate}
        />
      )}
      {showBulkRateModal && (
        <BulkApproveWithRateModal
          records={records.filter((r) => selectedIds.includes(r.id))}
          onClose={() => setShowBulkRateModal(false)}
          onSuccess={() => {
            setSelectedIds([]);
            fetchOvertime(pagination.page);
          }}
        />
)}
{showAddModal && (
  <AddOvertimeModal
    onClose={() => setShowAddModal(false)}
    onSuccess={() => fetchOvertime(pagination.page)}
  />
)}
    </div>
  );
};

export default OvertimeTable;